import { render, staticRenderFns } from "./SizeModelBox.vue?vue&type=template&id=5c714f6b&scoped=true&"
import script from "./SizeModelBox.vue?vue&type=script&lang=js&"
export * from "./SizeModelBox.vue?vue&type=script&lang=js&"
import style0 from "./SizeModelBox.vue?vue&type=style&index=0&id=5c714f6b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c714f6b",
  null
  
)

export default component.exports